export default [
    {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    {
        id: 2,
        name_ca: 'Registral',
        name_en: 'Registry',
        name_es: 'Registral'
    },
    {
        id: 3,
        name_ca: 'Cadastral',
        name_en: 'Cadastral',
        name_es: 'Catastral'
    },
    {
        id: 4,
        name_ca: 'Comprovada',
        name_en: 'Checked',
        name_es: 'Comprobada'
    }
]





// WEBPACK FOOTER //
// ./src/options/selected_areas.js